<template>
    <div class="card transitionHeight collapsibleContent" :style="currHeight">
        <div class="cardTitle" @click="toggleCollapse" ref="cTitle">
            <h2>{{title}}</h2>
            <button style="cursor: pointer;" v-if="!disableCollapse">
                <svg v-if="!isCollapsed" width="24" height="24">
                    <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"></path>
                </svg>
                <svg v-else width="24" height="24">
                    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"></path>
                </svg>
            </button>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'collapsible-card',
    props: [
        "title",
        "disableCollapse"
    ],
    data: () => ({
        isCollapsed: false,
        expandableHeight: 0,
        titleHeight: 50,
    }),
    mounted() {
        var globv = this;
        globv.adjustHeight();
        window.addEventListener('resize', globv.adjustHeight);
        window.addEventListener('orientationchange', globv.adjustHeight);
    },
    beforeDestroy() {
        var globv = this;
        window.removeEventListener('resize', globv.adjustHeight);
        window.removeEventListener('orientationchange', globv.adjustHeight);
    },
    methods: {
        toggleCollapse: function() {
            var globv = this;
            globv.isCollapsed = !globv.isCollapsed;
        },
        adjustHeight: function() {
            var globv = this;
            setTimeout(() => {
                globv.expandableHeight = globv.$slots.default[0].elm.offsetHeight;
                if (globv.expandableHeight < 400)
                    globv.expandableHeight = 400;
                globv.titleHeight = globv.$refs.cTitle.offsetHeight;
            }, 10);
        }
    },
    computed: {
        currHeight() {
            var globv = this;

            if (!globv.disableCollapse)
                return {
                    "max-height": globv.isCollapsed ? globv.titleHeight + "px" : globv.expandableHeight * 5 + 'px'
                }

            return {};
        }
    }
}
</script>

<style lang="scss">
.collapsibleContent {
    overflow: hidden;
}

</style>